// src/firebase.js
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { getAnalytics, logEvent } from "firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyDrNuQMUZ2BTC_UFYfxL0AZDTGPqUtNfQM",
    authDomain: "firstw-3e325.firebaseapp.com",
    databaseURL: "https://firstw-3e325.firebaseio.com",
    projectId: "firstw-3e325",
    storageBucket: "firstw-3e325.firebasestorage.app",
    messagingSenderId: "753605546566",
    appId: "1:753605546566:web:f3a8d0305980ef0444f047"
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Messaging
let messaging;
try {
    messaging = getMessaging(app);
} catch (error) {
    console.warn("Firebase Messaging failed to initialize (likely due to missing config or unsupported browser context):", error);
}

// VAPID Key (Web Push Certificate) from Project Settings > Cloud Messaging
const VAPID_KEY = "BNznZkUcJ6LTbqhRpYHocZ1MCL48e_l7ag-5XlNUpTt32b-T-62pIMq5Vy5Esjy3iq5Jl-ne5iB2d8OlsoCb-eo";

export const requestForToken = async () => {
    if (!messaging) return null;
    try {
        const currentToken = await getToken(messaging, { vapidKey: VAPID_KEY });
        if (currentToken) {
            console.log('current token for client: ', currentToken);
            return currentToken;
        } else {
            console.log('No registration token available. Request permission to generate one.');
            return null;
        }
    } catch (err) {
        console.log('An error occurred while retrieving token. ', err);
        return null;
    }
};

export const onMessageListener = () =>
    new Promise((resolve) => {
        if (!messaging) return;
        onMessage(messaging, (payload) => {
            console.log("payload", payload);
            resolve(payload);
        });
    });

// Initialize Analytics
let analytics;
try {
    analytics = getAnalytics(app);
} catch (error) {
    console.warn("Firebase Analytics failed to initialize:", error);
}

export const logErrorToAnalytics = (error, additionalParams = {}) => {
    if (analytics) {
        logEvent(analytics, 'app_error', {
            message: error.message,
            stack: error.stack,
            ...additionalParams
        });
        console.log("Logged error to Firebase Analytics:", error.message);
    } else {
        console.warn("Analytics not initialized, skipping logEvent.");
    }
};

export { analytics };
